import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store, { persistor } from '@/redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import '@shopify/polaris/build/esm/styles.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { config } from './config';
import '@shopify/polaris-viz/build/esm/styles.css';

function ErrorFallback({ error, resetErrorBoundary }: any) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => {}}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((e) => {
  const countReloadConfigShop = sessionStorage.getItem('countReloadConfigShop');
  if (!config.shop && !countReloadConfigShop) {
    sessionStorage.setItem('countReloadConfigShop', '1');
    window.location.reload();
  }

  if (e.name === 'LCP') {
    axios({
      url: `${process.env.REACT_APP_API_END_POINT}admin/dashboard/performance-log`,
      method: 'POST',
      data: {
        shop: config.shop,
        value: e.value,
        path: window.location.pathname,
      },
    }).catch((error) => {
      console.log(error);
    });
  }

  const countReloadFCP = localStorage.getItem('countReloadFCP') ? Number(localStorage.getItem('countReloadFCP')) : 0;
  if (e.name === 'FCP' && countReloadFCP <= 3) {
    if (e.value > 1800) {
      localStorage.setItem('countReloadFCP', (countReloadFCP + 1).toString());
      window.location.reload();
    }
  }
});
